export const GET_OPTIONS = "GET_OPTIONS"
export const GET_OPTIONS_REQUEST = "GET_OPTIONS_REQUEST"
export const GET_OPTIONS_SUCCESS = "GET_OPTIONS_SUCCESS"
export const GET_OPTIONS_ERROR = "GET_OPTIONS_ERROR"
export const SET_OPTIONS = "SET_OPTIONS"
